// Generated types for DatabaseReference
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI, NeoNodeWriteAPI } from './neonode';
import { NeoNodeReadAPISchemaObject, NeoNodeWriteAPISchemaObject } from './neonode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface DatabaseReferenceReadAPI extends Omit<NeoNodeReadAPI, 'id'> {
  id: string;
  label?: string | null;
}

export interface DatabaseReferenceWriteAPI extends NeoNodeWriteAPI {
  label?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const DatabaseReferenceReadAPISchema: z.ZodType<DatabaseReferenceReadAPI> = NeoNodeReadAPISchemaObject.omit({ 'id': true }).extend({
  id: z.string(),
  label: z.string().nullable().optional(),
}).passthrough();

export const DatabaseReferenceWriteAPISchema: z.ZodType<DatabaseReferenceWriteAPI> = NeoNodeWriteAPISchemaObject.extend({
  label: z.string().nullable().optional(),
}).passthrough();
